import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useState } from "react";

import { transactionService } from "../services/transactionService";
import { partnerLineService } from "../services/partnerLineService";
import { Partner, partnerService } from "../services/partnerService";
import {
  partnerWellSuperAppService,
  WellSuperApp,
} from "../services/partnerWellSuperAppService";
import { partnerMTLService } from "../services/partnerMtlService";
import { partnerAliveService } from "../services/partnerAliveService";

export function useAgreementLogic(partner: Partner | undefined) {
  const navigate = useNavigate();
  const location = useLocation();
  const agreementRef = useRef<HTMLDivElement>(null);
  const [isAgreementRead, setIsAgreementRead] = useState(false);
  const [isConsentMarketing, setIsConsentMarketing] = useState(false);

  //   const { onIndexMounted, partnerMtlIsActive } = usePartnerMTL();

  const scrollAgreementToBottom = () => {
    const element = agreementRef.current;
    if (element) {
      element.scrollTo({
        top: element.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const agree = async () => {
    if (!partner) return;

    // const agreementElement = agreementRef.current;
    // const agreementElementScrolledCompletely =
    //   agreementElement &&
    //   agreementElement.scrollHeight - agreementElement.scrollTop <=
    //     agreementElement.clientHeight + 10;

    // if (!agreementElementScrolledCompletely && !isAgreementRead) {
    //   scrollAgreementToBottom();
    //   return;
    // }

    setIsAgreementRead(true);

    partner.userConsent.isAcceptTerms = true;
    partner.userConsent.isConsent3rdParty = true;
    partner.userConsent.isConsentMarketing = isConsentMarketing;
    partnerService.setPartner(partner);

    try {
      // Partner: Line
      if (partnerLineService.isActive()) {
        if (
          partner.userData?.firstName &&
          partner.userData?.lastName &&
          partner.userData?.tel
        ) {
          await transactionService.register(
            partner.userData,
            partner.userConsent,
            partner.name,
            "Line Channel"
          );
          navigate("/confirm");
        } else {
          navigate("/register");
        }
        return;
      }

      // Partner: WellSuperApp
      //   if (partnerWellSuperAppService.isActive()) {
      //     console.log("WellSuperApp partner agreement logic");
      //     partnerWellSuperAppService.onIndexMounted(window.location);
      //     let updatedPartner = partnerService.getPartner() as Partner;

      //     const needsRegister =
      //       partnerWellSuperAppService.onIndexMountedRequiredRegister(
      //         updatedPartner.userData
      //       ) ||
      //       !updatedPartner.userData ||
      //       !updatedPartner.userData.firstName?.trim() ||
      //       !updatedPartner.userData.lastName?.trim() ||
      //       !updatedPartner.userData.tel?.trim();

      //     if (needsRegister) {
      //       navigate("/register");
      //       return;
      //     }

      //     try {
      //       updatedPartner.userConsent.isAcceptTerms = true;
      //       partnerService.setPartner(updatedPartner);

      //       const isGuardianMode = Boolean(
      //         (updatedPartner as WellSuperApp).guardianId
      //       );

      //       if (!updatedPartner.userData) {
      //         navigate("/register");
      //         return;
      //       }

      //       console.log(" Updated partner data at agreement:", updatedPartner);

      //       // Refresh partner from partnerService
      //       updatedPartner = partnerService.getPartner() as Partner;

      //       await transactionService.register(
      //         updatedPartner.userData!,
      //         updatedPartner.userConsent,
      //         updatedPartner.name,
      //         "",
      //         isGuardianMode,
      //         (updatedPartner as WellSuperApp).hospitalId
      //       );

      //       navigate("/confirm");
      //       return;
      //     } catch (error: any) {
      //       console.error("WellSuperApp auto register failed", error);
      //       navigate("/register");
      //       return;
      //     }
      //   }
      else if (partnerWellSuperAppService.isActive()) {
        await partnerWellSuperAppService.onIndexMounted(window.location);
        partner = partnerService.getPartner() as Partner;

        if (
          partnerWellSuperAppService.onIndexMountedRequiredRegister(
            partner.userData
          ) ||
          !partner.userData ||
          !partner.userData?.firstName?.trim() ||
          !partner.userData?.lastName?.trim() ||
          !partner.userData?.tel?.trim()
        ) {
          await navigate("/register");
          return true;
        } else {
          try {
            partner.userConsent.isAcceptTerms = true;
            partnerService.setPartner(partner);

            const isGuardianMode = !!(partner as WellSuperApp).guardianId;

            partner = partnerService.getPartner() as Partner;
            
            console.log(" Partner data at agreement:", partner);

            await transactionService.register(
              partner.userData!,
              partner.userConsent,
              partner.name,
              "",
              isGuardianMode,
              (partner as WellSuperApp).hospitalId
            );

            await navigate("/confirm");
            return true;
          } catch (error) {
            console.error("WellSuperApp auto register failed", error);

            await navigate("/register");

            // @ts-ignore
            commit("ERROR", err.message);
            return true;
          }
        }
      }
      // Partner: MTL
      else if (partnerMTLService.isActive()) {
        console.log("MTL partner agreement logic");

        console.log(partner.userData, partner.userConsent, partner.name);

        if (!partner.userData) {
          navigate("/connect-failed");
          return true;
        }

        partnerMTLService.onIndexMounted(window.location);

        console.log("Partner data at agreement:", partner);

        // Refresh partner from partnerService
        partner = partnerService.getPartner() as Partner;

        await transactionService.register(
          partner.userData!,
          partner.userConsent,
          partner.name
        );

        sessionStorage.setItem("userData", JSON.stringify(partner.userData));

        navigate("/confirm");
        return;
      }

      // Partner: No user data
      if (!partner.userToken || !partner.userData) {
        navigate("/register");
        return;
      }

      // Partner: Partners with user data from token.
      else {
        await transactionService.register(
          partner.userData,
          partner.userConsent,
          partner.name
        );

        if (partnerAliveService.isActive()) {
          await navigate("/call");
          return;
        }

        await navigate("/confirm");
        return;
      }
    } catch (e) {
      console.error(e);
      navigate("/register");
    }
  };

  return {
    agree,
    agreementRef,
    isAgreementRead,
    setIsConsentMarketing,
    isConsentMarketing,
    isLoading,
  };
}
